import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class ProductLifeCycleService {
    private readonly getProductLifeCycleURL = `/admin/product-lifecycle/events`;

    // ---------------------------------------------------------------

    getTraceability(params: { size: number; page: number; eventType: string; startDate: string; endDate: string }) {
        return fetchWithRetry(API.get(this.getProductLifeCycleURL, { params }));
    }
}

export default new ProductLifeCycleService();
